import FlashcardsCardGrid from "@/components/flashcards/FlashcardsCardGrid";
import { useFlashcardsStudySession } from "@/hooks/flashcards/useFlashcardsStudySession";
import { cn } from "@/lib/utils";
import type { TextFlashcardData } from "@/types/storyboard";

interface FlashcardsDeckStudyPaneProps {
  deckTitle: string;
  cards: TextFlashcardData[];
  className?: string;
}

/**
 * Right-hand study pane in the Lernkarten picker — fitContainer flip grid for
 * the selected deck. The deck title only labels the region: the highlighted
 * deck in the list already shows it. The tinted ground comes from the
 * surrounding `ModalSplitLayout` main pane.
 */
const FlashcardsDeckStudyPane = ({
  deckTitle,
  cards,
  className,
}: FlashcardsDeckStudyPaneProps) => {
  const { flippedByIndex, flipCard } = useFlashcardsStudySession();

  return (
    <section
      aria-label={deckTitle}
      className={cn("flex min-h-0 flex-1 flex-col overflow-hidden", className)}
    >
      {/* Top padding keeps the grid clear of the modal's close button. */}
      <div className="interactive-element flex min-h-0 flex-1 flex-col overflow-y-auto p-4 pt-14 md:overflow-hidden">
        <FlashcardsCardGrid
          cards={cards}
          flippedByIndex={flippedByIndex}
          onFlip={flipCard}
          fitContainer
        />
      </div>
    </section>
  );
};

export default FlashcardsDeckStudyPane;
